/**
 * Контракт сервиса чата поддержки (Baraka Chat Service). Ходим через прокси
 * `/api/chat/*` — он подставляет `X-API-Key`, `X-Client-Type` и `X-User-Id`.
 */

/** Статус комнаты: закрытую читают, но писать в неё нельзя. */
export const CHAT_STATUS = { open: 1, closed: 2 } as const

/** Кто написал: 1 — клиент, 2 — оператор. */
export const SENDER_TYPE = { customer: 1, agent: 2 } as const

export interface ChatAttachmentDto {
  id: string
  fileName: string
  /** Путь относительно сервиса — на клиенте достраиваем через прокси */
  fileUrl: string
  fileType: string
  fileSize: number
}

export interface ChatRoomDto {
  id: string
  customerId: string
  orderId: string | null
  /** Номер заказа приходит вместе с комнатой — отдельный запрос не нужен */
  orderNumber: number | null
  status: number
  unreadCount: number
  isViewedByAgent: boolean
  createdAt: string
  closedAt: string | null
  lastMessageAt: string | null
  lastMessageContent: string | null
  assignedAgentId?: string | null
}

export interface ChatMessageDto {
  id: string
  chatRoomId: string
  senderId: string
  senderName: string | null
  senderType: number
  content: string | null
  sentAt: string
  readAt: string | null
  attachments: ChatAttachmentDto[]
}

/** Список комнат приходит страницами, но у клиента их единицы. */
export interface ChatListDto {
  items: ChatRoomDto[]
  totalCount: number
  page: number
  pageSize: number
}

export interface CreateChatBody {
  customerId: string
  /** Обращение без заказа сервис тоже принимает */
  orderId?: string
  /** Обязателен вместе с `orderId` — иначе сервис отвечает 400 */
  orderNumber?: number
}

export interface SendMessageBody {
  senderId: string
  senderType: number
  content: string
  attachmentIds?: string[]
}
